import { signIn } from "features/Authentication/services/AuthService";
import { loginSuccess, logoutUserSuccess, ACCESS_TOKEN_KEY } from "./reducer";
import { AppDispatch } from "store";
import { toast } from "react-toastify";

function loginErrorMessage(err: unknown): string {
  const ax = err as {
    response?: { data?: { message?: string } };
    message?: string;
  };
  return (
    ax.response?.data?.message ||
    ax.message ||
    "Sign-in failed. Check your email and password."
  );
}

export const loginUser =
  (
    payload: { email: string; password: string },
    navigate: (path: string) => void,
  ) =>
  async (dispatch: AppDispatch) => {
    try {
      const response = await signIn(payload);

      if (response.success && response.data) {
        const { user, token, permissions } = response.data;

        localStorage.setItem(ACCESS_TOKEN_KEY, token);

        dispatch(
          loginSuccess({
            user,
            token,
            permissions,
          }),
        );

        toast.success("Logged in successfully");
        navigate("/dashboard");
        return;
      }

      toast.error(response.message || "Invalid email or password");
    } catch (err) {
      toast.error(loginErrorMessage(err));
    }
  };

// Logout thunk
export const logoutUser = (navigate?: any) => async (dispatch: AppDispatch) => {
  try {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    dispatch(logoutUserSuccess());
    if (navigate) navigate("/login");
    toast.success("Logged out successfully");
  } catch (err) {
    toast.error("Failed to logout");
  }
};
